import { BlobServiceClient } from "@azure/storage-blob";

export interface IBlobStorage {
    account: string;
    sas: string;
    containerName: string;
    blobName: string;
}

export async function blobToString(blob: any) {
    const fileReader = new FileReader();
    return new Promise((resolve, reject) => {
        fileReader.onloadend = (ev) => {
            resolve(ev.target?.result);
        };
        fileReader.onerror = reject;
        fileReader.readAsText(blob);
    });
}

export function getAccountFromBlobUrl(url: string): string {
    const regex = /https?:\/\/(\w+)\.blob\.core\.windows\.net/;
    const match = RegExp(regex).exec(url);

    if (match && match.length >= 2) return match[1];

    return "";
}

export function getSasTokenFromBlobUrl(url: string): string {
    const delimiterIndex = url.indexOf("?");
    return delimiterIndex !== -1 ? url.substring(delimiterIndex + 1) : "";
}

export async function getBlobStorageString({
    account,
    sas,
    containerName,
    blobName,
}: IBlobStorage): Promise<Blob | undefined> {
    const blobServiceClient = new BlobServiceClient(
        `https://${account}.blob.core.windows.net?${sas}`
    );

    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blobClient = containerClient.getBlobClient(blobName);

    try {
        const downloadBlockBlobResponse = await blobClient.download();

        // eslint-disable-next-line sonarjs/prefer-immediate-return
        const downloaded = await downloadBlockBlobResponse.blobBody;

        return downloaded;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log("[ERROR]", error);
        return undefined;
    }
    // const downloadBlockBlobResponse = await blobClient.download();
    // console.log("downloadBlockBlobResponse", downloadBlockBlobResponse);

    // // eslint-disable-next-line sonarjs/prefer-immediate-return
    // const downloaded = await downloadBlockBlobResponse.blobBody;

    // return downloaded;
}
